import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import * as bootstrap from "bootstrap";
import "./form.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../components/Pagination";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Table from "../../../components/table";
import api from "../../../api/api";
import { useAuth } from "../../../context/AuthContext";
import usePagination from "../../../utils/usePagination";
 
const AllNotifications = () => {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
 
  const navigate = useNavigate();
 
  useEffect(() => {
    const fetchAllNotifications = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        if (!token) return;
 
        const response = await api.get(`/notifications/user/${user.user_id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
 
        const allNotifications = Array.isArray(response.data.data.notifications)
          ? response.data.data.notifications
          : [];
 
        setNotifications(allNotifications);
      } catch (err) {
        setError("Failed to fetch notifications");
        console.error("Failed to fetch notifications:", err);
      } finally {
        setLoading(false);
      }
    };
 
    if (user) {
      fetchAllNotifications();
    }
  }, [user]);
 
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(notifications, 5);
 
  const handleNotificationClick = async (notif) => {
    try {
      await api.put(`/notifications/${notif.id}/read`);
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
 
    if (notif.type === "quotation_accepted") {
      navigate(`/view-quotation/${notif.enq_id}`);
    } else if (notif.type === "callback_requested") {
      navigate(`/view-enquiry-details/${notif.enq_id}`);
    } else if (notif.type === "new_enquiry") {
      navigate(`/send-quotation/${notif.enq_id}`);
    } else if (notif.type === "enquiry_updated") {
      navigate(`/my-enquiry/view-enquiry-details/${notif.enq_id}`);
    } else if (notif.type === "quotation_sent") {
      navigate(`/view-quotation/${notif.enq_id}`);
    } else if (notif.type === "si_created" || notif.type === "si_updated") {
      navigate(`/view-si/${notif.enq_id}`);
    } else if (notif.type === "documents_uploaded") {
      navigate(`/view-booking-documents/${notif.enq_id}`);
    }
  };
  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]'),
    );
 
    const tooltipInstances = tooltipTriggerList.map((el) => {
      // If tooltip already exists, dispose it first
      const existing = bootstrap.Tooltip.getInstance(el);
      if (existing) {
        existing.dispose();
      }
 
      return new bootstrap.Tooltip(el, {
        trigger: "hover", // ONLY hover
        placement: "top",
        container: "body", // prevents stuck inside table
      });
    });
 
    return () => {
      tooltipInstances.forEach((tooltip) => tooltip.dispose());
    };
  }, [currentItems]);
  if (error) return <p>{error}</p>;
 
  const columns = [
    {
      label: "Message",
      render: (item) => (
        <span data-bs-toggle="tooltip" title={item.message}>
          {item.message}
        </span>
      ),
    },
    {
      label: "Type",
      accessor: "type",
    },
    {
      label: "Date",
      render: (item) => (
        <span>{new Date(item.created_at).toLocaleDateString()}</span>
      ),
    },
    {
      label: "Action",
      render: (item) => (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => handleNotificationClick(item)}
        >
          <ArrowForwardIcon />
        </div>
      ),
    },
  ];
 
  return (
    <>
      <Breadcrumbs />
 
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No notifications found."
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalItems={totalItems}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
        }
      />
    </>
  );
};
 
export default AllNotifications;